import axios from 'axios'
import { host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-money-log'

const buildHeaders = (token) => ({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': token
})

export const getListMoneyLog = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: buildHeaders(token)
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getSummaryMoneyLog = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary`, {
        ...query
    }, {
        headers: buildHeaders(token)
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const exportAllMoneyLog = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/export-all`, {
        ...query
    }, {
        headers: buildHeaders(token)
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}
